import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";
function Newsletter_48() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter September 2026
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            EU Clarifies Verification and Accreditation Requirements for CBAM
            Implementation.
          </title>
          <meta
            name="description"
            content="The European Commission has issued new guidance on verification and accreditation under the Carbon Border Adjustment Mechanism, supporting implementation of the definitive regime that began on 1 January 2026."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          EU Clarifies Verification and Accreditation Requirements for CBAM
          Implementation.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/September_2026_1.webp")}
            alt="EU Clarifies Verification and Accreditation Requirements for CBAM Implementation."
            loading="lazy"
          />
        </figure>
        <p>
          The European Commission has issued new guidance on verification and
          accreditation under the Carbon Border Adjustment Mechanism, supporting
          implementation of the definitive regime that began on 1 January 2026.
          The guidance clarifies requirements for verifiers assessing embedded
          emissions from non-EU installations producing CBAM-covered goods and
          for National Accreditation Bodies responsible for accrediting and
          supervising those verifiers.
        </p>
        <p>
          Accreditation is the first formal step before verifiers can access the
          CBAM Registry. From 1 September 2026, accredited verifiers may apply
          for Registry access through the relevant national competent authority,
          which checks accreditation status. Verifiers are required to register
          within two months of receiving accreditation. From January 2027, they
          can issue verification reports in the Registry, enabling importers to
          use verified actual emissions in their CBAM declarations.
        </p>
        <p>
          The framework complements recent EU implementing and delegated
          regulations governing verification principles, verifier
          qualifications, emissions calculation methods and accreditation
          oversight. These measures strengthen consistency in emissions data,
          traceability and assurance across CBAM supply chains as reporting
          moves from the transitional phase to financial compliance across
          covered sectors.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The guidance is expected to reduce procedural ambiguity by
            standardising verifier accreditation, registry access, and emissions
            assurance. For market participants, this may simplify compliance
            planning, improve data reliability, and enable more predictable cost
            assessment. It also reinforces the role of independent verification
            in strengthening CBAM preparedness and carbon-accounting discipline.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          China Unifies Environmental Legislation Under New Ecological and
          Environmental Code.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/September_2026_2.webp")}
              alt="China Unifies Environmental Legislation Under New Ecological and Environmental Code."
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          China's Ecological and Environmental Code came into force in August
          2026, following its adoption by the national legislature in March. As
          the country's second formal statutory code after the Civil Code, it
          consolidates more than 30 existing laws, over 100 administrative
          regulations, and around 1,000 local regulations into a unified
          framework of 1,242 articles across five chapters addressing pollution
          control, ecological protection, and green development.
        </p>
        <p>
          The consolidation follows notable environmental progress. By the end
          of 2025, average PM2.5 concentrations in major cities had declined to
          28 micrograms per cubic metre, with 89.3 per cent of days recording
          good air quality, both record levels. National forest coverage
          exceeded 25 per cent, and China has contributed roughly a quarter of
          global afforestation since 2000. The country has also established more
          than 8,000 national-level green factories, alongside the world's
          largest clean power and steel production systems, and its largest
          carbon emissions trading market.
        </p>
        <p>
          The code supports China's Beautiful China Plan for the 2026–2030
          period and aligns with its 2030 carbon peaking target, providing a
          codified legal foundation intended to guide implementation,
          enforcement, and judicial interpretation of environmental standards
          across pollution management, resource conservation, and industrial
          transition in the years ahead.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            For corporates, the consolidated code signals stronger, more
            predictable enforcement, making environmental compliance a sharper
            risk factor rather than a formality. Businesses operating in China
            should reassess permitting, emissions reporting, and supply chain
            practices accordingly, while early investment in cleaner production
            and credible ESG data may support better access to green financing
            and markets.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          The U.S. Department of Energy Commits $500 Million to Strengthen
          Domestic Critical Minerals and Battery Supply Chains.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/September_2026_3.webp")}
            alt="The U.S. Department of Energy Commits $500 Million to Strengthen Domestic Critical Minerals and Battery Supply Chains."
            loading="lazy"
          />
        </figure>
        <p>
          The U.S. Department of Energy has announced $500 million in funding to
          advance domestic critical mineral processing and battery manufacturing
          capacity. Allocated through the Office of Critical Minerals and Energy
          Innovation, the funding supports seven selected projects covering
          demonstration-scale processing, commercial facility construction, and
          retrofitting of existing plants for battery materials manufacturing
          and recycling. This is the third such funding round under the
          Department's broader supply chain resilience effort.
        </p>
        <p>
          The initiative responds to a well-documented dependency on imported
          critical minerals. According to the U.S. Geological Survey, the United
          States remains more than 50 percent import-reliant for 54 mineral
          commodities and fully import-dependent for 16, including gallium,
          graphite, and manganese. A single supplier nation accounts for a
          significant share of several of these imports, underscoring the
          rationale for expanding domestic processing and recycling
          infrastructure
        </p>
        <p>
          Battery materials are central to sectors including electric vehicles,
          grid storage, and consumer electronics, making supply chain resilience
          increasingly relevant to energy and industrial policy. The funding
          aligns with wider federal efforts to diversify sourcing, encourage
          domestic investment, and reduce exposure to single-country supply
          concentration across the value chain.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            This development holds significant relevance for corporates, as it
            reflects growing policy momentum toward domestic supply chain
            diversification and reduced dependency on concentrated mineral
            sources. Companies should reassess supply chain risk exposure,
            evaluate domestic sourcing and recycling partnerships, and align
            procurement strategies with evolving critical minerals policy, while
            preparing for potential incentives, disclosure expectations, and
            long-term resource security considerations across the battery and
            clean energy value chain.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          IFRS Foundation Sets Five-Year Direction for Global Reporting
          Standards.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/September_2026_4.webp")}
            alt="IFRS Foundation Sets Five-Year Direction for Global Reporting Standards. "
            loading="lazy"
          />
        </figure>
        <p>
          The IFRS Foundation Trustees have approved a five-year operating and
          financing plan for the IASB and ISSB, setting priorities for the
          continued development, implementation and maintenance of global
          financial and sustainability disclosure standards. The plan also
          addresses long-term funding resilience as demand for consistent,
          comparable reporting continues to expand across international markets.
        </p>
        <p>
          The decision comes as adoption of ISSB Standards continues to grow,
          with more than 45 jurisdictions already using or taking steps toward
          their application. Companies in 18 jurisdictions are expected to begin
          reporting using ISSB Standards by 2027. The five-year plan is intended
          to support implementation, standard-setting activities and engagement
          as sustainability-related disclosures become increasingly incorporated
          into regulatory and reporting frameworks.
        </p>
        <p>
          Alongside the plan, the Trustees have proposed constitutional
          amendments, including reducing the IASB and ISSB to 10 members each
          from 2028 while preserving geographic and professional diversity. The
          consultation on these proposed changes remains open until 16 November
          2026, providing stakeholders with an opportunity to contribute to the
          future governance structure of international standard-setting.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Global adoption of ISSB Standards across more than 45 jurisdictions
            gives the five-year plan wider significance in the sustainability
            reporting landscape. Companies in 18 jurisdictions are expected to
            report using these standards by 2027, reflecting increasing
            regulatory alignment. This momentum supports greater comparability,
            more consistent disclosure practices and a stronger common baseline
            for sustainability-related financial information across markets.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Canada Outlines C$70 Billion Clean Energy and Critical Minerals
          Infrastructure Program.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/September_2026_5.webp")}
            alt="Canada Outlines C$70 Billion Clean Energy and Critical Minerals Infrastructure Program."
            loading="lazy"
          />
        </figure>

        <p>
          Canada has announced a major clean electricity and infrastructure
          program in Labrador, representing nearly C$70 billion in planned
          investment, supported by up to C$10 billion in federal financing and
          investment. The program includes upgrades to Churchill Falls,
          development of the Gull Island hydroelectric project, new transmission
          infrastructure and supporting works intended to strengthen critical
          minerals development.
        </p>
        <p>
          Planned improvements at Churchill Falls could add up to 2,500 MW of
          generating capacity, while Gull Island is expected to provide 2,700 MW
          and generate approximately 12 TWh of electricity annually when
          operational in 2036–2037. More than 660 kilometres of transmission
          infrastructure is proposed, alongside a 735 kV connection to Labrador
          West and consideration of up to 2,000 MW of onshore wind generation.
        </p>
        <p>
          The program supports Canada’s objective of doubling electricity-grid
          capacity by 2050 and complements federal clean-economy investment tax
          credits. Infrastructure investment in Labrador is also expected to
          support lower-carbon industrial activity, electricity reliability and
          development of critical mineral resources required for clean-energy
          supply chains.
        </p>
        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Industrial decarbonisation can benefit from expanded clean-power
            capacity through lower Scope 2 emissions, greater electrification
            potential, and improved access to low-carbon electricity. Stronger
            grid infrastructure can also support renewable integration, energy
            resilience, and more sustainable metals, mining, manufacturing, and
            processing operations aligned with evolving low-carbon supply-chain
            requirements.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_48;
